module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-brass-brushed-4042-panel.88bf4484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-brass-brushed-4042-panel.jpg
// module id = 1112
// module chunks = 37